import { useTranslation } from 'react-i18next';
import styles from './SummaryCardDetail.module.css';
import { createPortal } from 'react-dom';

interface SummaryCardDetailProps {
	stepId: number | null;
	isOpen: boolean;
	onCancel: () => void;
}

const SummaryCardDetail = ({ stepId, isOpen, onCancel }: SummaryCardDetailProps) => {
	const { t } = useTranslation();

	if (!isOpen) return null;

	let titleKey = '';
	let longDescriptionKey = '';

	switch (stepId) {
		case 1:
			titleKey = t('summaryCards.step2Title');
			longDescriptionKey = t('summaryCards.details.step2LongDesc');
			break;
		case 2:
			titleKey = t('summaryCards.step1Title');
			longDescriptionKey = t('summaryCards.details.step1LongDesc');
			break;
		case 3:
			titleKey = t('summaryCards.step3Title');
			longDescriptionKey = t('summaryCards.details.step3LongDesc');
			break;
		default:
			return null;
	}

	const handleBackdropClick = (e: React.MouseEvent) => {
		if (e.target === e.currentTarget) {
			onCancel();
		}
	};

	return createPortal(
		<div className={styles.overlay} onClick={handleBackdropClick}>
			<div className={styles.step_container}>
				<div className={styles.border_glow}></div>
				<div className={styles.dialog}>
					<div className={styles.header}>
						<h3 className={styles.title}>{titleKey}</h3>
					</div>

					<div className={styles.body}>
						<p className={styles.message}>{longDescriptionKey}</p>
					</div>
				</div>
			</div>
		</div>,
		document.body
	);
};

export default SummaryCardDetail;
